import React from 'react';
import './AboutUs.css';

import { PageTitle } from '../../../components';
import { About, Testimonials, Counter, WhyUs, Team, Services, Process, Partners, Awards, Mission, HomeBanner } from '../../../sections';



const AboutUs = () => {
  return (
    <>

      {/* Page title */}
      <PageTitle title={'about us'} page={'about us'} />

      <section className='about-us'>

        <About /> {/* About section */}
        <Counter /> {/* Counter section */}
        <Services /> {/* Services section */}
        <WhyUs /> {/* Why Us section */}
        <Process /> {/* Process section */}
        <Testimonials /> {/* Testimonials section */}
        <Team /> {/* Team section */}
        <Mission /> {/* Mission section */}
        <Awards /> {/* Achievements and awards section */}
        <HomeBanner /> {/* Banner section */}
        <Partners /> {/* Partners Section */}

      </section>

    </>
  );
}

export default AboutUs;